<!--快捷 历史记录-->
<template>
    <div class="id">
        <div class="navBar" @click="$router.back()">
            <van-icon name="arrow-left" />
            {{ $t('历史账单') }}
        </div>
        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#ffffff"
            title-inactive-color="#888" color="#dfdfdf">
            <van-tab v-for="(item, index) in source" :key="index" :title="item.name">
                <div class="table">
                    <!-- 表头 -->
                    <van-row class="header">
                        <van-col span="5" class="vanItem">{{ $t('种类') }}</van-col>
                        <van-col span="5" class="vanItem">{{ $t('总金额')}}</van-col>
                        <van-col span="5" class="vanItem">{{ $t('币种') }}</van-col>
                        <van-col span="5" class="vanItem">{{ $t('数量') }}</van-col>
                        <van-col span="4" class="vanItem">{{ $t('状态') }}</van-col>
                    </van-row>
                    <!-- 数据 -->
                    <div class="scroll">
                        <van-row v-for="(item, index) in users" :key="index" class="row">
                            <van-col span="5" class="trade">
                                <div>BTC</div>
                                <div>USDT</div>
                            </van-col>
                            <van-col span="5" class="trade">{{ item.age }}</van-col>
                            <van-col span="5" class="trade">
                                交易
                            </van-col>
                            <van-col span="5" class="trade">
                                交易
                            </van-col>
                            <van-col span="4" class="trade">
                                交易
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import { get } from '@/http/request'

export default {
    components: {
    },
    data() {
        return {
            value: '',
            active: '1',
            source: [
                {
                    name: '全部订单'
                },
                {
                    name: '已完成'
                },
                {
                    name: '未完成'
                }
            ],
            users: [
                { name: "张三", age: 25, city: "北京" },
                { name: "李四", age: 30, city: "上海" },
                { name: "王五", age: 28, city: "广州" },
                { name: "张三", age: 25, city: "北京" },
                { name: "李四", age: 30, city: "上海" },
                { name: "王五", age: 28, city: "广州" },
                { name: "张三", age: 25, city: "北京" },
                { name: "李四", age: 30, city: "上海" },
                { name: "王五", age: 28, city: "广州" },
                { name: "张三", age: 25, city: "北京" },
                { name: "李四", age: 30, city: "上海" },
                { name: "王五", age: 28, city: "广州" }

            ],
            bbb: false
        };
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {
        onChange(name, title) {
            console.log("切换到", name, title)
        },
        aaa() {
            this.$router.push('/mobile/register')
            // GET 示例
            get('getUserInfo', { id: 1 }).then(res => {
                console.log('用户信息', res)
            })

            // POST 示例
            // post('login', { username: 'test', password: '123456' }).then(res => {
            //     console.log('登录成功', res)
            // })
        }

    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 0 15px;
    padding-top: 50px;
    font-size: 14px;

    .navBar {
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    ::v-deep .van-tabs__wrap {
        border-bottom: 1px solid #323233;
    }

    .title {
        display: flex;
        align-items: center;
        font-size: 30px;
        padding-bottom: 20px;
        padding-top: 30px;
    }

    .table {
        background: #000;
        color: #fff;
        margin-top: 10px;

        .header {
            font-weight: bold;
            background: #1c222c;
            padding: 14px 0;
            border-radius: 5px;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 74vh;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE/Edge */
        }

        .row {
            border-bottom: 1px solid #222b39;
            padding: 20px 0px;
            display: flex;
            align-items: center;

            .trade {
                text-align: center;
            }
        }
    }
}
</style>
